import { jsx as _jsx } from "react/jsx-runtime";
import { Arrow } from '@commercial-website/icons';
import { ButtonLink } from '../../atoms/button/button-link';
import { MediaFill } from '../../atoms/media-fill/media-fill';
import { billboardHeroMock } from '../billboard-hero/mock';
const splitHeroMedia = {
    video: {
        webm: 'https://cdn.sanity.io/files/x38k87cj/production/41b5947ebade234ed4a1abf5d3e065c9f4ff8bbb.webm',
        mp4: 'https://cdn.sanity.io/files/x38k87cj/production/9c3deccd14e761af4ce73cc0346e13901b641248.mp4',
    },
    poster: 'https://cdn.sanity.io/images/x38k87cj/production/6657cac8e651122b5240827e2a2db2124f82fae5-1392x1306.jpg?h=1204&fit=max&auto=format',
};
export const splitHeroMock = {
    media: _jsx(MediaFill, { media: splitHeroMedia }),
    title: 'The business expense card built for clarity',
    description: 'Easily control business expenses in 50+ currencies, with bank-level security and cashback on all card spend',
    children: _jsx(ButtonLink, { variant: "pink", icon: _jsx(Arrow, {}), label: "Get started", href: "/en/demo" }),
    logoRow: {
        caption: billboardHeroMock.logoRow.caption,
        logos: billboardHeroMock.logoRow.logos,
    },
};
